var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_setup.appLoading)?_c('div',{staticClass:"u-w-full u-absolute u-min-h-screen u-bg-black u-opacity-75 u-z-50 u-flex u-justify-center"},[_c('img',{staticClass:"u-flex u-justify-center",attrs:{"src":require("../../assets/img/spinner.svg"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }